import React, { Component } from 'react'
import styled from 'styled-components'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  FacebookShareCount,
  LinkedinShareCount,
} from 'react-share'
import {
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaTelegramPlane,
} from 'react-icons/fa'
import urljoin from 'url-join'
import config from '../../../data/SiteConfig'
import Button from '../CustomButtons/Button.jsx'

class SocialLinks extends Component {
  render() {
    const { postNode, postPath, mobile } = this.props
    const post = postNode.frontmatter
    const url = urljoin(config.siteUrl, config.pathPrefix, postPath)
    const iconSize = mobile ? 36 : 48

    return (
      <SocialContainer>
        <h5>Share this article</h5>
        <SocialFlex>
          <FacebookShareButton url={url} quote={postNode.excerpt}>
            <Button justIcon round color="facebook">
              <FaFacebook size={iconSize} />
            </Button>
          </FacebookShareButton>
          <LinkedinShareButton
            url={url}
            title={post.title}
            description={postNode.excerpt}
          >
            <Button justIcon round color="linkedin">
              <FaLinkedin size={iconSize} />
            </Button>
          </LinkedinShareButton>
          <TwitterShareButton url={url} title={post.title}>
            <Button justIcon round color="twitter">
              <FaTwitter size={iconSize} />
            </Button>
          </TwitterShareButton>
          <TelegramShareButton url={url}>
            <Button justIcon round color="telegram">
              <FaTelegramPlane size={iconSize} />
            </Button>
          </TelegramShareButton>
        </SocialFlex>
      </SocialContainer>
    )
  }
}

const SocialFlex = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;

  > div {
    margin: 0 0.5rem;
  }
`

const SocialContainer = styled.div`
  margin-top: 2rem;
  text-align: center;
`

export default SocialLinks



// WEBPACK FOOTER //
// ./src/components/SocialLinks/SocialLinks.jsx